import Header from "../../components/Header";
import FooterItem from "../../components/FooterItem";
import React from 'react';
import { FloatButton, Masonry } from 'antd';
import PostCard from "../../components/PostCard";
import {ArticleList} from "../../api/mockData";

function Home(){
    const items = ArticleList.map((article, arrayIndex) => ({
    key: article.id,
    index: article.id, 
    height: 120 + Math.random() * 100 
    }));
    return (
        <div id="home-container">
            <Header />
            <Masonry
                columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
                gutter={{ xs: 8, sm: 12, md: 16 }}
                items={items}
                itemRender={item => (
                    //id = index + 1
                    <PostCard id = {item.index+1} height = {item.height}/>
                )}
            />
            <hr/>
            <FooterItem />
            <FloatButton.BackTop 
            className = "back-top-button" 
            visibilityHeight={100}
            />
        </div>
    )
}
export default Home;